import dayjs from 'dayjs';

export function normalizeEmail(value: string | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }
  return value.replace(/[\s\p{Cf}\p{Cc}]/gu, '').toLowerCase();
}

declare global {
  interface String {
    splitUppercase(): string;
    abbreviate(length: number): string;
    toShortDate(format?: string): string;
    toLongDate(format?: string): string;
    isEmpty(): boolean;
    isValidJSONObject(): boolean;
  }
}

String.prototype.splitUppercase = function (): string {
  return this.split(/(?=[A-Z])/).join(' ');
};

String.prototype.abbreviate = function (length: number): string {
  if (this.length <= length) {
    return this.toString();
  } else {
    return this.slice(0, length) + '...';
  }
};

String.prototype.toShortDate = function (format?: string): string {
  const f = format ?? 'MM/DD/YYYY';
  return dayjs(`${this as string}`).format(f);
};

String.prototype.toLongDate = function (format?: string): string {
  const f = format ?? 'MM/DD/YYYY  h:mm A';
  return dayjs(`${this as string}Z`).format(f);
};

String.prototype.isEmpty = function (): boolean {
  if (this === undefined) {
    return true;
  }

  if (this.trim().length === 0) {
    return true;
  }

  return false;
};

/**
 * If you don't care about primitives and only objects then this function
 * is for you, otherwise look elsewhere.
 * This function will return `false` for any valid json primitive.
 * EG, 'true' -> false
 *     '123' -> false
 *     'null' -> false
 *     '"I'm a string"' -> false
 */
String.prototype.isValidJSONObject = function (): boolean {
  try {
    const o = JSON.parse(this as string);

    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (o && typeof o === 'object') {
      return true;
    }
  } catch {
    // We return false, so this is "handled."
    return false;
  }

  return false;
};
